import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";

import searchUserResponseAdapter from "../../../adapters/searchUserAdapter";
import routes from "../../../constants/routes";

const PHONE_SECRET = process.env.REACT_APP_PHONE_SECRET;

export const useStudentNavigation = () => {
  const navigate = useNavigate();

  const navigateToStudentDetails = useCallback(
    (selectedProfile, searchValues, selectedBranch) => {
      const { account, profile } = selectedProfile;
      const adaptedData = searchUserResponseAdapter(account, profile);

      const queryParams = new URLSearchParams();
      queryParams.append("vertical", searchValues.vertical);

      if (searchValues.phone) {
        const encrypted = CryptoJS.AES.encrypt(
          searchValues.phone,
          PHONE_SECRET,
        ).toString();
        queryParams.append("phone", encrypted);
      }
      if (searchValues.uam_id)
        queryParams.append("uam_id", searchValues.uam_id);
      if (searchValues.admission_number)
        queryParams.append("admission_number", searchValues.admission_number);
      if (searchValues.country_id)
        queryParams.append("countryId", String(searchValues.country_id));
      if (searchValues.isd_code)
        queryParams.append("isdCode", searchValues.isd_code);

      navigate(`${routes.studentDetails}?${queryParams.toString()}`, {
        state: {
          studentData: adaptedData,
          vertical: searchValues.vertical,
          phone: account.phone || searchValues.phone,
          branch_id: selectedBranch?.id || "",
          branch_name: selectedBranch?.name || "",
        },
      });
    },
    [navigate],
  );

  return { navigateToStudentDetails };
};
